// Breadcrumb identifiers
const productBreadcrumbIdentifier = {
    route: 'products.products.show',
    parameterLabel: 'product',
    parameters: ['product']
}
const productPlanBreadcrumbIdentifier = {
    route: 'products.products.plans.edit',
    parameterLabel: 'plan',
    parameters: ['product', 'plan']
}
const productPriceBreadcrumbIdentifier = {
    route: 'products.products.plans.prices.edit',
    parameterLabel: 'productPrice',
    parameters: ['product', 'plan', 'productPrice']
}
const productGroupBreadcrumbIdentifier = {
    route: 'products.product-groups.edit',
    parameterLabel: 'product_group',
    parameters: ['product_group']
}
const productPackageBreadcrumbIdentifier = {
    route: 'products.product-packages.edit',
    parameterLabel: 'product_package',
    parameters: ['product_package']
}
const productAddonBreadcrumbIdentifier = {
    route: 'products.product-addons.show',
    parameterLabel: 'product',
    parameters: ['product']
}
const ProductSubTypeBreadcrumbIdentifier = {
    route: 'products.sub-types.edit',
    parameterLabel: 'sub_type',
    parameters: ['sub_type']
}
const productAddonGroupBreadcrumbIdentifier = {
    route: 'products.product-addon-groups.edit',
    parameterLabel: 'product_group',
    parameters: ['product_group']
}
const DhpExtensionBreadcrumbIdentifier = {
    route: 'settings.dhp-extensions.edit',
    parameterLabel: 'dhp_extension',
    parameters: ['dhp_extension']
}
const productAddonPlanBreadcrumbIdentifier = {
    route: 'products.product-addons.products.plans.edit',
    parameterLabel: 'plan',
    parameters: ['product', 'plan']
}
const productAddonPriceBreadcrumbIdentifier = {
    route: 'products.product-addons.products.plans.prices.edit',
    parameterLabel: 'productPrice',
    parameters: ['product', 'plan', 'productPrice']
}
const TldMappingBreadcrumbIdentifier = {
    route: 'products.tld-product-mappings.edit',
    parameterLabel: 'tld_product_mapping',
    parameters: ['tld_product_mapping']
}
const productClassesBreadcrumbIdentifier = {
    route: 'products.product-classes.edit',
    parameterLabel: 'product_class',
    parameters: ['product_class']
}
const terminationRuleBreadcrumbIdentifier = {
    route: 'products.termination-rules.edit',
    parameterLabel: 'termination_rule',
    parameters: ['termination_rule']
}
const partnerApiProductBreadcrumbIdentifier = {
    route: 'products.partner-api-products.edit',
    parameterLabel: 'contract',
    parameters: ['contract']
}

export default ($page) => {
    return [
        {
            route: 'products.products.index',
            label: 'messages.sitemap.products.products',
            showInSidebar: true,
            permissions: ['product.view'],
            id: 'products-index',
            children: [
                {
                    route: 'products.products.create',
                    label: 'messages.sitemap.products.create'
                },
                {
                    route: 'products.products.copy',
                    label: 'messages.sitemap.products.copy',
                    identifier: productBreadcrumbIdentifier
                },
                {
                    route: 'products.products.edit',
                    label: 'messages.sitemap.products.edit',
                    identifier: productBreadcrumbIdentifier,
                    children: [
                        {
                            route: 'products.products.translations',
                            label: 'messages.sitemap.products.translations',
                            showInSidebar: false
                        }
                    ]
                },
                {
                    route: 'products.products.show',
                    label: 'messages.sitemap.products.show',
                    identifier: productBreadcrumbIdentifier,
                    children: [
                        {
                            route: 'products.products.plans-advanced-view',
                            label: 'messages.sitemap.products.plans_advanced_view',
                            identifier: productBreadcrumbIdentifier
                        }
                    ]
                },
                {
                    route: 'products.products.show',
                    label: 'messages.sitemap.products.plans.plans',
                    identifier: productBreadcrumbIdentifier,
                    children: [
                        {
                            route: 'products.products.plans.create',
                            label: 'messages.sitemap.products.plans.create'
                        },
                        {
                            route: 'products.products.plans.edit',
                            label: 'messages.sitemap.products.plans.edit',
                            identifier: productPlanBreadcrumbIdentifier
                        },
                        {
                            route: 'products.products.plans.edit',
                            label: 'messages.sitemap.products.prices.prices',
                            identifier: productPlanBreadcrumbIdentifier,
                            children: [
                                {
                                    route: 'products.products.plans.prices.create',
                                    label: 'messages.sitemap.products.prices.create'
                                },
                                {
                                    route: 'products.products.plans.prices.edit',
                                    label: 'messages.sitemap.products.prices.edit',
                                    identifier: productPriceBreadcrumbIdentifier
                                }
                            ]
                        }
                    ]
                },
                {
                    route: 'products.products.index',
                    label: 'messages.sitemap.products.groups.groups',
                    children: [
                        {
                            route: 'products.product-groups.create',
                            label: 'messages.sitemap.products.groups.create'
                        },
                        {
                            route: 'products.product-groups.edit',
                            label: 'messages.sitemap.products.groups.edit',
                            identifier: productGroupBreadcrumbIdentifier
                        }
                    ]
                },
                {
                    route: 'products.products.advanced-view',
                    label: 'messages.sitemap.products.advanced_view'
                },
                {
                    route: 'products.products.download-upload',
                    label: 'messages.sitemap.products.download_upload'
                },
                {
                    route: 'products.products.plans.import.create',
                    label: 'messages.sitemap.products.product_plans_import'
                },
                {
                    route: 'products.plans.import.retry.show',
                    label: 'messages.sitemap.products.product_plans_import'
                },
            ]
        },
        {
            route: 'products.product-packages.index',
            label: 'messages.sitemap.products.product_packages.product_packages',
            showInSidebar: true,
            permissions: ['product.manage_packages'],
            id: 'products-packages',
            children: [
                {
                    route: 'products.product-packages.create',
                    label: 'messages.sitemap.products.product_packages.create'
                },
                {
                    route: 'products.product-packages.edit',
                    label: 'messages.sitemap.products.product_packages.edit',
                    identifier: productPackageBreadcrumbIdentifier
                }
            ]
        },
        {
            route: 'products.sub-types.index',
            label: 'messages.sitemap.products.sub_types.sub_types',
            showInSidebar: true,
            permissions: ['products.sub_types'],
            id: 'sub-types',
            children: [
                {
                    route: 'products.sub-types.create',
                    label: 'messages.sitemap.products.sub_types.create'
                },
                {
                    route: 'products.sub-types.edit',
                    label: 'messages.sitemap.products.sub_types.edit',
                    identifier: ProductSubTypeBreadcrumbIdentifier
                }
            ]
        },
        {
            route: 'products.product-addons.index',
            label: 'messages.sitemap.products.product_addons.product_addons',
            showInSidebar: true,
            permissions: ['product.edit', 'product.view'],
            id: 'product-addons',
            children: [
                {
                    route: 'products.product-addons.create',
                    label: 'messages.sitemap.products.product_addons.create'
                },
                {
                    route: 'products.product-addons.copy',
                    label: 'messages.sitemap.products.product_addons.copy',
                    identifier: productAddonBreadcrumbIdentifier
                },
                {
                    route: 'products.product-addons.show',
                    label: 'messages.sitemap.products.product_addons.show',
                    identifier: productAddonBreadcrumbIdentifier,
                    children: [
                        {
                            route: 'products.product-addons.products.plans.create',
                            label: 'messages.sitemap.products.plans.create'
                        },
                        {
                            route: 'products.product-addons.products.plans.edit',
                            label: 'messages.sitemap.products.plans.edit',
                            identifier: productAddonPlanBreadcrumbIdentifier
                        },
                        {
                            route: 'products.product-addons.products.plans.edit',
                            label: 'messages.sitemap.products.prices.prices',
                            identifier: productAddonPlanBreadcrumbIdentifier,
                            children: [
                                {
                                    route: 'products.product-addons.products.plans.prices.create',
                                    label: 'messages.sitemap.products.prices.create'
                                },
                                {
                                    route: 'products.product-addons.products.plans.prices.edit',
                                    label: 'messages.sitemap.products.prices.edit',
                                    identifier: productAddonPriceBreadcrumbIdentifier
                                }
                            ]
                        }
                    ]
                },
                {
                    route: 'products.product-addons.edit',
                    label: 'messages.sitemap.products.product_addons.edit',
                    identifier: productAddonBreadcrumbIdentifier
                },
                {
                    route: 'products.product-addon-groups.create',
                    label: 'messages.sitemap.products.addon_groups.create'
                },
                {
                    route: 'products.product-addon-groups.edit',
                    label: 'messages.sitemap.products.addon_groups.edit',
                    identifier: productAddonGroupBreadcrumbIdentifier
                },
                {
                    route: 'products.product-addons.download-upload',
                    label: 'messages.sitemap.products.product_addons.download_upload'
                },
                {
                    route: 'products.product-addons.plans.import.create',
                    label: 'messages.sitemap.products.product_plans_import'
                },
                {
                    route: 'products.product-addons.plans.import.retry.show',
                    label: 'messages.sitemap.products.product_plans_import'
                },
            ]
        },
        ...($page.props.modules.kamp_dhp
            ? [
                {
                    route: 'settings.dhp-extensions.index',
                    label: 'messages.sitemap.products.dhp_extensions.dhp_extensions',
                    showInSidebar: true,
                    permissions: ['billing_and_accounting.price_adjustments.dhp'],
                    id: 'products-dhp-extensions-index',
                    children: [
                        {
                            route: 'settings.dhp-extensions.edit',
                            label: 'messages.sitemap.products.dhp_extensions.edit',
                            identifier: DhpExtensionBreadcrumbIdentifier
                        },
                        {
                            route: 'settings.dhp-extensions.create',
                            label: 'messages.sitemap.products.dhp_extensions.create'
                        }
                    ]
                }
            ]
            : []
        ),
        ...($page.props.modules.domains
            ? [
                {
                    route: 'products.tld-product-mappings.index',
                    label: 'messages.sitemap.products.tld_mappings.tld_mappings',
                    showInSidebar: true,
                    permissions: ['product.tld_mapping'],
                    id: 'tld-mappings',
                    children: [
                        {
                            route: 'products.tld-product-mappings.create',
                            label: 'messages.sitemap.products.tld_mappings.create'
                        },
                        {
                            route: 'products.tld-product-mappings.edit',
                            label: 'messages.sitemap.products.tld_mappings.edit',
                            identifier: TldMappingBreadcrumbIdentifier
                        }
                    ]
                }
            ]
            : []
        ),
        {
            route: 'products.product-classes.index',
            label: 'messages.sitemap.products.product-classes.product-classes',
            showInSidebar: true,
            permissions: ['product.classes'],
            id: 'product-classes-index',
            children: [
                {
                    route: 'products.product-classes.create',
                    label: 'messages.sitemap.products.product-classes.create'
                },
                {
                    route: 'products.product-classes.edit',
                    label: 'messages.sitemap.products.product-classes.edit',
                    identifier: productClassesBreadcrumbIdentifier
                }
            ]
        },
        {
            route: 'products.termination-rules.index',
            label: 'messages.sitemap.products.termination-rules.termination-rules',
            showInSidebar: true,
            permissions: ['product.termination_rules.edit', 'product.termination_rules.view'],
            id: 'termination-rules-index',
            children: [
                {
                    route: 'products.termination-rules.create',
                    label: 'messages.sitemap.products.termination-rules.create',
                    permissions: ['product.termination_rules.edit']
                },
                {
                    route: 'products.termination-rules.edit',
                    label: 'messages.sitemap.products.termination-rules.edit',
                    permissions: ['product.termination_rules.edit'],
                    identifier: terminationRuleBreadcrumbIdentifier
                }
            ]
        },
        ...($page.props.modules.partner_api
            ? [
                {
                    route: 'products.partner-api-products.index',
                    label: 'messages.sitemap.products.partner_api_products.partner_api_products',
                    showInSidebar: true,
                    permissions: ['products.partner_api'],
                    id: 'partner-api-products-index',
                    children: [
                        {
                            route: 'products.partner-api-products.edit',
                            label: 'messages.sitemap.products.partner_api_products.edit',
                            identifier: partnerApiProductBreadcrumbIdentifier
                        }
                    ]
                }
            ]
            : []
        ),
        {
            route: 'products.products.products-price-plan-coverage',
            label: 'messages.sitemap.products.products_price_plan_coverage',
            showInSidebar: false,
            permissions: ['product.view'],
            id: 'products-price-plan-coverage',
        },
        {
            route: 'products.products.addon-products-price-plan-coverage',
            label: 'messages.sitemap.products.addon_products_price_plan_coverage',
            showInSidebar: false,
            permissions: ['product.view'],
            id: 'addon-products-price-plan-coverage',
        }
    ]
}
